import { render, staticRenderFns } from "./PageContainer.vue?vue&type=template&id=35e81cd3&scoped=true"
import script from "./PageContainer.vue?vue&type=script&lang=ts"
export * from "./PageContainer.vue?vue&type=script&lang=ts"
import style0 from "./PageContainer.vue?vue&type=style&index=0&id=35e81cd3&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e81cd3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35e81cd3')) {
      api.createRecord('35e81cd3', component.options)
    } else {
      api.reload('35e81cd3', component.options)
    }
    module.hot.accept("./PageContainer.vue?vue&type=template&id=35e81cd3&scoped=true", function () {
      api.rerender('35e81cd3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layout-editor/PageContainer.vue"
export default component.exports